import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'objectHandler'})
export class ObjectHandlerPipe implements PipeTransform {
  transform(obj: any): any {
    return obj !== null && obj !== undefined ? obj : '';
  }
}